import localStorageAvailable from "../../utils/localStorageAvailable";
import axios from "../../utils/axios";


const getCreatedQrs = async (
    user,
    method,
    data,
    params
) => {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable
        ? localStorage.getItem("accessToken")
        : "";
    const config = {
        method,
        maxBodyLength: Infinity,
        url: `/service/events_service/v1/events/wa/top_up/qr`,
        headers: {
            authorization: `Bearer ${accessToken}`,
            user,
        },
        data,
        params

    };
    const response = await axios.request(config);
    return response.data;
};

export default getCreatedQrs;
